import { lazy } from "react";
import BookIcon from "@mui/icons-material/Book";

const EventLogsList = lazy(() => import(".."));

const LogsRoute = {
  icon: BookIcon,
  name: "Event Logs",
  link: "/event-logs",
  path: "event-logs",
  index: -1,
  element: <EventLogsList />,
  permission: 'EventLog-Read'
};
export default LogsRoute;
